import React from 'react'
import { Box, Typography } from '@mui/material'
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { browserTime, dateFormat, dateTimeFormat } from 'utils/time'
import { money } from '../../../../components/Reporting'

export default function Chart({ config, points, title, currency }) {
  if (!points?.length) return <Box py={6} textAlign="center"><Typography color="text.secondary">No data for this period.</Typography></Box>
  return <Box role="img" aria-label={`${title} over the selected period${currency ? ' in USD' : ''}`}>
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={points} margin={{ top: 12, right: 16, left: 12, bottom: 8 }}>
        <CartesianGrid stroke="#E4EDF3" vertical={false} />
        <XAxis dataKey="time" tickFormatter={value => browserTime(value).format(config?.grouping === 'HOUR' ? 'MM/DD HH:mm' : dateFormat)} tick={{ fontSize: 11 }} minTickGap={35} />
        <YAxis tickFormatter={value => currency ? `$${value}` : value} allowDecimals={currency} tick={{ fontSize: 11 }} width={65} />
        <Tooltip formatter={value => [currency ? money(value) : Number(value).toLocaleString('en-US'), title]} labelFormatter={value => browserTime(value).format(dateTimeFormat)} />
        <Area type={config?.graphType === 'BUDGET' ? 'stepAfter' : 'linear'} dataKey="count" stroke="#0E75BD" fill="#E4EDF3" strokeWidth={2} isAnimationActive={false} />
      </AreaChart>
    </ResponsiveContainer>
  </Box>
}
